/** Build-time environment variable schema for CDK. */

import { EnvironmentConfig } from "@visioni/a3s-environments";
import { Json } from "@visioni/a3s-codecs";
import z from "zod/v4";

/**
 * Build-time configuration passed as environment variables
 *
 * If you add any keys here, make sure you add them to ../../babel.config.js for cache invalidation.
 *
 * Note: We use 'environments' as the schema key, but must use 'EXPO_PUBLIC_ENVIRONMENTS'
 * for process.env because that's how Expo statically replaces environment variables at build time.
 */
export const Env = z.object({
  environments: Json(EnvironmentConfig).optional(),
});

/**
 * Meta tag namespace prefix for environment variables in index.html
 * Meta tags are named 'a3s:{ENV_KEY}' to match Env schema keys
 */
export const ENVIRONMENT_META_NAMESPACE = "a3s:" as const;
